'use client'

import AgencyAwards from '@/components/sections/AgencyAwards'
import AgencyHero from '@/components/sections/AgencyHero'
import AgencyManifesto from '@/components/sections/AgencyManifesto'
import AgencyTeam from '@/components/sections/AgencyTeam'
import AgencyWhyUs from '@/components/sections/AgencyWhyUs'
import HomeAmbientBackground from '@/components/sections/HomeAmbientBackground'

export default function AgencyClient() {
  return (
    <div className="relative min-h-screen overflow-x-hidden pt-0">
      <HomeAmbientBackground />
      <AgencyHero />
      <AgencyManifesto />
      <AgencyTeam />
      <AgencyAwards />
      <AgencyWhyUs />
    </div>
  )
}
